import { db } from "../firebaseConfig";
import { isDateEarlier } from "../services/utilityService";
import {
  collection,
  query,
  getDocs,
  addDoc,
  where,
  doc,
  documentId,
  updateDoc,
  deleteDoc,
  orderBy,
  getDoc,
  //eslint-disable-next-line
  setLogLevel,
} from "firebase/firestore";
import { Buffer } from "buffer";
export let globalData = {};
globalData.access = new Map();
globalData.access.set("earlyArrival", "");
globalData.access.set("llc", "");
globalData.access.set("lateStay", "");

//

export async function getProfiles(orgCode) {
  const snapshot = await getDocs(
    query(
      collection(db, "profiles"),
      where("orgCode", "==", orgCode),
      orderBy("name")
    )
  );
  const profiles = new Map();
  snapshot.docs.map((doc) =>
    profiles.set(doc.data().uid, { uId: doc.id, ...doc.data() })
  );
  return profiles;
}

export async function verifyOrgCode(orgCode, email, setVerified) {
  let domains = [];
  const snapshot = await getDocs(
    query(
      collection(db, "organizations"),
      where("orgCode", "==", orgCode),
      where("active", "==", true)
    )
  );

  if (!snapshot.empty) {
    if (snapshot.docs[0].data().domains === "") {
      setVerified(true);
      return true;
    } else {
      domains = snapshot.docs[0].data().domains.split(",");
      for (let i = 0; i < domains.length; i++) {
        if (email.includes(domains[i])) {
          setVerified(true);
          return true;
        }
      }
    }
    setVerified(false);
    return false;
  } else {
    setVerified(false);
  }
}

export async function getMembers(orgCode, termId) {
  const snapshot = await getDocs(
    query(
      collection(db, "members"),
      where("orgCode", "==", orgCode),
      where("termId", "==", termId),
      orderBy("last")
    )
  );
  return snapshot.docs.map((doc) => ({
    id: doc.id,
    ...doc.data(),
  }));
}

export async function getGroups(uid, orgCode, type, termId) {
  let snapshot;
  if (type === "my") {
    snapshot = await getDocs(
      query(
        collection(db, "groups"),
        where("ownerId", "==", uid),
        where("termId", "==", termId),
        orderBy("name")
      )
    );
  } else if (type === "all") {
    snapshot = await getDocs(
      query(
        collection(db, "groups"),
        where("orgCode", "==", orgCode),
        where("termId", "==", termId),
        orderBy("name")
      )
    );
  }
  return snapshot.docs.map((doc) => ({
    id: doc.id,
    ...doc.data(),
  }));
}

export async function createGroup(name, date, term, orgCode, ownerId) {
  const data = {
    ownerId,
    orgCode,
    term: term,
    name,
    date,
    termId: term.id,
    status: "Pending",
    groupSize: 0,
  };
  const docRef = await addDoc(collection(db, "groups"), data);
  return docRef;
}
export async function saveGroup(group) {
  const groupRef = doc(db, "groups", group.id);
  const data = {
    name: group.name,
    date: group.date,
    term: group.term,
    status: group.status,
    ownerId: group.ownerId,
  };
  await updateDoc(groupRef, data);
  if (group.updatedDate === true) {
    getGroupMembers(group).then((members) => {
      members.forEach((m) => {
        deleteGroupMember(m.id, group.id).then(() => {
          const docRef = doc(db, "members", m.id);
          getDoc(docRef).then((docSnap) =>
            addToGroup(docSnap.data().orgId, group)
          );
        });
      });
    });
    group.updatedDate = false;
  }
}

export async function deleteGroup(groupId, ownerId, setGroups) {
  await deleteDoc(doc(db, "groups", groupId));
}

export async function getGroupMembers(group) {
  //Query group memberships
  const groupMemberships = await getDocs(
    query(collection(db, "groupMemberships"), where("groupId", "==", group.id))
  );

  //Check memberships were found
  if (!groupMemberships.empty) {
    const memberIds = [];
    const membershipStatusMap = new Map();

    //Collect member IDs for each membership
    groupMemberships.forEach((member) => {
      membershipStatusMap.set(member.data().memberId, member.data().status);
      memberIds.push(member.data().memberId);
    });

    let subList = [];

    //Break member IDs into lists of 10
    for (var i = 0; i < memberIds.length; i += 10) {
      subList.push(
        memberIds.slice(
          i,
          i + 10 > memberIds.length ? memberIds.length : i + 10
        )
      );
    }
    let promises = [];

    //For each list of member IDs, create query promise
    subList.forEach((element) => {
      promises.push(
        getDocs(
          query(collection(db, "members"), where(documentId(), "in", element))
        )
      );
    });

    //Execute all queries
    return await Promise.all(promises).then((results) =>
      results
        .map((snapshot) =>
          snapshot.docs.map((doc) => ({
            id: doc.id,
            ...doc.data(),
            membershipStatus: membershipStatusMap.get(doc.id),
          }))
        )
        .flat()
    );
  }
}

export async function addToGroup(id, group) {
  const membersSnapshot = await getDocs(
    query(
      collection(db, "members"),
      where("orgId", "==", id),
      where("termId", "==", group.termId)
    )
  );
  if (!membersSnapshot.empty) {
    const data = {
      memberId: membersSnapshot.docs[0].id,
      groupId: group.id,
      status: "Pending",
    };
    await addDoc(collection(db, "groupMemberships"), data);
    if (
      isDateEarlier(group.date, membersSnapshot.docs[0].data().earliestDate)
    ) {
      const memberRef = doc(db, "members", membersSnapshot.docs[0].id);
      const data = {
        earliestDate: group.date,
        earliestGroup: group.name,
        status: "Pending",
      };
      await updateDoc(memberRef, data);
    }
  } else {
    const memberData = {
      first: "Loading...",
      last: "Loading...",
      earliestDate: group.date,
      earliestGroup: group.name,
      orgCode: group.orgCode,
      orgId: id,
      termId: group.termId,
      status: "Pending",
    };
    const memberRef = await addDoc(collection(db, "members"), memberData);
    const groupMembershipData = {
      memberId: memberRef.id,
      groupId: group.id,
      status: "Pending",
    };
    await addDoc(collection(db, "groupMemberships"), groupMembershipData);
  }
  const membershipsSnap = await getDocs(
    query(collection(db, "groupMemberships"), where("groupId", "==", group.id))
  );
  const groupRef = doc(db, "groups", group.id);
  await updateDoc(groupRef, { groupSize: membershipsSnap.docs.length });
}

export async function getTerms(orgCode, admin) {
  let terms = null;

  if (admin) {
    terms = await getDocs(
      query(
        collection(db, "terms"),
        where("orgCode", "==", orgCode),
        orderBy("name")
      )
    );
  } else {
    terms = await getDocs(
      query(
        collection(db, "terms"),
        where("orgCode", "==", orgCode),
        where("active", "==", true),
        orderBy("name")
      )
    );
  }

  return terms.docs.map((doc) => ({
    id: doc.id,
    ...doc.data(),
  }));
}

export async function getUsers(orgCode, activeOnly) {
  let terms = [];
  if (activeOnly) {
    terms = await getDocs(
      query(
        collection(db, "profiles"),
        where("orgCode", "==", orgCode),
        where("active", "==", true),
        orderBy("name")
      )
    );
  } else {
    terms = await getDocs(
      query(
        collection(db, "profiles"),
        where("orgCode", "==", orgCode),
        orderBy("name")
      )
    );
  }
  return terms.docs.map((doc) => ({
    id: doc.id,
    ...doc.data(),
  }));
}

export async function updateUser(user) {
  const userRef = doc(db, "profiles", user.id);
  const data = {
    ...user,
  };
  await updateDoc(userRef, data);
}

export async function createTerm(
  name,
  orgId,
  orgCode,
  termDates,
  earliest,
  latest,
  active,
  admin
) {
  const data = {
    name,
    orgId,
    orgCode,
    processed: false,
    termDates: termDates,
    earliest: earliest,
    latest: latest,
    active: active,
    processedEarlyArrivals: false,
  };
  await addDoc(collection(db, "terms"), data);
  return await getTerms(orgCode, admin);
}

export async function saveTerm(
  id,
  name,
  orgId,
  orgCode,
  processed,
  termDates,
  earliest,
  latest,
  active,
  processedEarlyArrivals,
  admin
) {
  const termRef = doc(db, "terms", id);
  const data = {
    name: name,
    orgId: orgId,
    processed: processed,
    termDates: termDates,
    earliest: earliest,
    latest: latest,
    active: active,
    processedEarlyArrivals: processedEarlyArrivals,
  };
  await updateDoc(termRef, data);
  return getTerms(orgCode, admin);
}

export async function deleteTerm(term) {
  await deleteDoc(doc(db, "terms", term.id));
}

export async function deleteGroupMember(memberId, groupId) {
  const groupMemberships = await getDocs(
    query(
      collection(db, "groupMemberships"),
      where("groupId", "==", groupId),
      where("memberId", "==", memberId)
    )
  );
  if (!groupMemberships.empty) {
    const groupMembership = groupMemberships.docs[0];
    await deleteDoc(doc(db, "groupMemberships", groupMembership.id));
    const memberRef = doc(db, "members", memberId);
    const remainingMemberships = await getDocs(
      query(
        collection(db, "groupMemberships"),
        where("memberId", "==", memberId)
      )
    );
    if (!remainingMemberships.empty) {
      const groupIds = [];
      remainingMemberships.docs.forEach((doc) =>
        groupIds.push(doc.data().groupId)
      );
      const groups = await getDocs(
        query(collection(db, "groups"), where(documentId(), "in", groupIds))
      );
      let earliest = groups.docs[0].data().date;
      let earliestGroup = "";
      groups.docs.forEach((g) => {
        if (Date.parse(g.data().date) <= Date.parse(earliest)) {
          earliest = g.data().date;
          earliestGroup = g.data().name;
        }
      });
      await updateDoc(memberRef, {
        earliestDate: earliest,
        earliestGroup: earliestGroup,
      });
    } else {
      await updateDoc(memberRef, { earliestDate: "0", earliestGroup: "" });
    }
  }
  const membershipsSnap = await getDocs(
    query(collection(db, "groupMemberships"), where("groupId", "==", groupId))
  );
  const groupRef = doc(db, "groups", groupId);
  await updateDoc(groupRef, { groupSize: membershipsSnap.docs.length });
}

export async function getOrganization(orgCode) {
  const snapshot = await getDocs(
    query(collection(db, "organizations"), where("orgCode", "==", orgCode))
  );
  if (!snapshot.empty) {
    return await { id: snapshot.docs[0].id, ...snapshot.docs[0].data() };
  }
}

export async function saveCredentials(username, password, org) {
  const secret = Buffer.from(username + ":" + password).toString("base64");
  const data = { secret: secret };
  const orgRef = doc(db, "organizations", org.id);
  await updateDoc(orgRef, data);
}

export async function clearCredentials(org) {
  const orgRef = doc(db, "organizations", org.id);
  const data = { secret: "" };
  await updateDoc(orgRef, data);
}

export async function saveOrganization(org) {
  const orgRef = doc(db, "organizations", org.id);
  const data = { fieldId: org.fieldId, domains: org.domains };
  await updateDoc(orgRef, data);
}

export async function getMessages(orgCode, active, enforceDates) {
  let systemSnapshot = await getDocs(
    query(
      collection(db, "messages"),
      where("type", "==", "system"),
      where("active", "==", true)
    )
  );

  if (systemSnapshot.empty) systemSnapshot = null;

  let orgSnapshot;
  if (active) {
    orgSnapshot = await getDocs(
      query(
        collection(db, "messages"),
        where("type", "==", "organization"),
        where("orgCode", "==", orgCode),
        where("active", "==", true)
      )
    );
  } else {
    orgSnapshot = await getDocs(
      query(
        collection(db, "messages"),
        where("type", "==", "organization"),
        where("orgCode", "==", orgCode)
      )
    );
  }

  let orgMessages;
  if (orgSnapshot.empty) orgMessages = null;
  else {
    orgMessages = orgSnapshot.docs.map((doc) => ({
      id: doc.id,
      ...doc.data(),
    }));
    if (enforceDates)
      orgMessages = orgMessages.filter(
        (m) =>
          Date.parse(m.start) < Date.now() && Date.parse(m.end) > Date.now()
      );
  }

  let systemMessages;
  if (systemSnapshot.empty) systemMessages = null;
  else {
    systemMessages = systemSnapshot.docs.map((doc) => ({
      id: doc.id,
      ...doc.data(),
    }));
    if (enforceDates)
      systemMessages = systemMessages.filter(
        (m) =>
          Date.parse(m.start) < Date.now() && Date.parse(m.end) > Date.now()
      );
  }

  return {
    orgMessages: orgMessages,
    systemMessages: systemMessages,
  };
}

export async function saveMessage(id, start, end, active, content) {
  const messageRef = doc(db, "messages", id);
  const data = { start: start, end: end, active: active, content: content };
  await updateDoc(messageRef, data);
}

export async function createMessage(start, end, active, content, orgCode) {
  const data = {
    start: start,
    end: end,
    active: active,
    content: content,
    orgCode: orgCode,
    type: "organization",
  };
  await addDoc(collection(db, "messages"), data);
  //await updateDoc(docRef, {data});
}

export async function getAccessKeys(orgCode) {
  const snapshot = await getDocs(
    query(
      collection(db, "access"),
      where("orgCode", "==", orgCode),
      orderBy("name")
    )
  );
  return snapshot.docs.map((doc) => ({
    id: doc.id,
    ...doc.data(),
  }));
}

export async function loadGlobalData(profile) {
  globalData.access = new Map();
  const snapshot = await getDocs(
    query(collection(db, "access"), where("orgCode", "==", profile.orgCode))
  );

  snapshot.docs.map((doc) =>
    profile.admin === true
      ? globalData.access.set(`${doc.data().name}`, doc.data().adminStatus)
      : globalData.access.set(`${doc.data().name}`, doc.data().userStatus)
  );

  globalData.profile = profile;
}

export async function saveKey(selectedKey) {
  const keyRef = doc(db, "access", selectedKey.id);
  const data = { ...selectedKey };
  await updateDoc(keyRef, data);
}

export async function approveEarlyArrival(memberId, groupId) {
  const groupMemberships = await getDocs(
    query(
      collection(db, "groupMemberships"),
      where("groupId", "==", groupId),
      where("memberId", "==", memberId)
    )
  );

  if (!groupMemberships.empty) {
    const membership = groupMemberships.docs[0];
    const docRef = doc(db, "groupMemberships", membership.id);
    const data = { status: "Approved" };
    await updateDoc(docRef, data);
  }

  evaluateEarlyArrivalMember(memberId);
}

export async function denyEarlyArrival(memberId, groupId) {
  const groupMemberships = await getDocs(
    query(
      collection(db, "groupMemberships"),
      where("groupId", "==", groupId),
      where("memberId", "==", memberId)
    )
  );

  if (!groupMemberships.empty) {
    const membership = groupMemberships.docs[0];
    const docRef = doc(db, "groupMemberships", membership.id);
    const data = { status: "Denied" };
    await updateDoc(docRef, data);
  }

  evaluateEarlyArrivalMember(memberId);
}

export async function evaluateEarlyArrivalMember(memberId) {
  const memberRef = await doc(db, "members", memberId);

  let data = {
    earliestDate: "0",
    earliestGroup: "",
  };

  const pendingMemberships = await getDocs(
    query(
      collection(db, "groupMemberships"),
      where("memberId", "==", memberId),
      where("status", "==", "Pending")
    )
  );

  const approvedMemberships = await getDocs(
    query(
      collection(db, "groupMemberships"),
      where("memberId", "==", memberId),
      where("status", "==", "Approved")
    )
  );

  const deniedMemberships = await getDocs(
    query(
      collection(db, "groupMemberships"),
      where("memberId", "==", memberId),
      where("status", "==", "Denied")
    )
  );

  if (!pendingMemberships.empty) {
    pendingMemberships.docs.forEach((m) => {
      getDoc(doc(db, "groups", m.data()["groupId"])).then((groupSnap) => {
        if (isDateEarlier(groupSnap.data()["date"], data.earliestDate)) {
          data = {
            earliestDate: groupSnap.data()["date"],
            earliestGroup: groupSnap.data()["name"],
            status: "Pending",
          };
          updateDoc(memberRef, data);
        }
      });
    });
  } else if (!approvedMemberships.empty) {
    approvedMemberships.docs.forEach((m) => {
      getDoc(doc(db, "groups", m.data()["groupId"])).then((groupSnap) => {
        if (isDateEarlier(groupSnap.data()["date"], data.earliestDate)) {
          data = {
            earliestDate: groupSnap.data()["date"],
            earliestGroup: groupSnap.data()["name"],
            status: "Approved",
          };
          updateDoc(memberRef, data);
        }
      });
    });
  } else if (!deniedMemberships.empty) {
    deniedMemberships.docs.forEach((m) => {
      getDoc(doc(db, "groups", m.data()["groupId"])).then((groupSnap) => {
        if (isDateEarlier(groupSnap.data()["date"], data.earliestDate)) {
          data = {
            earliestDate: groupSnap.data()["date"],
            earliestGroup: groupSnap.data()["name"],
            status: "Denied",
          };
          updateDoc(memberRef, data);
        }
      });
    });
  } else {
    data = { earliestGroup: "", earliestDate: "0", status: "" };
  }

  //update the member group date and name
}
